import {emptyStateSpotlight} from '../assets';
import {FaHouseBuildingIcon, FaNewspaperIcon, FaSparklesIcon, FontAwesomeIcon} from '../components/icon';
import type {ListingPageEmptyState} from '../components/listing/ListingPage';

const PROPERTY_ICON = <FontAwesomeIcon icon={FaHouseBuildingIcon} style={{fontSize: 32}} aria-hidden />;
const NEWS_ICON = <FontAwesomeIcon icon={FaNewspaperIcon} style={{fontSize: 36}} aria-hidden />;

export const NEWS_EMPTY: ListingPageEmptyState = {
  titleKey: 'empty_news_title',
  bodyKey: 'empty_news_body',
  icon: NEWS_ICON,
};

export const PROJECTS_EMPTY: ListingPageEmptyState = {
  titleKey: 'featured_project_empty',
  icon: PROPERTY_ICON,
};

export const EXPANSIONS_EMPTY: ListingPageEmptyState = {
  titleKey: 'expansions_empty',
  icon: PROPERTY_ICON,
};

export const UNIT_TYPES_EMPTY: ListingPageEmptyState = {
  titleKey: 'unit_types_empty',
  icon: PROPERTY_ICON,
};

export const COUNTRIES_EMPTY: ListingPageEmptyState = {
  titleKey: 'no_projects_country_page_title',
  icon: PROPERTY_ICON,
};

export const LATEST_NEWS_EMPTY: ListingPageEmptyState = {
  bodyKey: 'lastest_news_empty',
  icon: NEWS_ICON,
};

export const SPOTLIGHT_EMPTY: ListingPageEmptyState = {
  bodyKey: 'spotlight_empty',
  icon: <FontAwesomeIcon icon={FaSparklesIcon} aria-hidden />,
  illustration: emptyStateSpotlight,
  tone: 'background',
};
